import styled from 'styled-components';

import { FlexColumnCenterAligned, textStyles } from '@/styled/common';

export const ErrorContainer = styled(FlexColumnCenterAligned)`
  padding: 15px 30px;
  height: 100%;
  width: 100%;
`;

export const ErrorText = styled(FlexColumnCenterAligned)`
  text-align: center;
  width: 295px;
  margin-top: 20px;
`;
export const ErrorHeading = styled.div`
  ${textStyles};
  font-weight: 700;
`;

export const ErrorDetails = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 15px;
  height: ${({ theme }) => theme.text.secondary};
`;
